// Plain-language explanations of the stock profile's financial metrics, shown
// as hovers. Shared by the Financial Metrics block and the Competition table
// (issue #445) — moved out of AiAnalysisPanel so the table can import it
// without a circular import.
export const METRIC_DESCRIPTIONS = {
  revenueGrowth: "Year-over-year growth in company's revenue",
  pegRatio: "Price/Earnings to Growth ratio - measures stock's value while considering company's growth",
  priceToSales: "Price-to-Sales ratio - compares company's stock price to its revenues",
  enterpriseToRevenue: "Enterprise Value to Revenue ratio - measures company's total value relative to its revenue",
  enterpriseToEbitda: "Enterprise Value to EBITDA ratio - measures company's total value relative to its earnings before interest, taxes, depreciation, and amortization",
  grossMargins: "Percentage of revenue remaining after cost of goods sold",
  operatingMargins: "Percentage of revenue remaining after operating expenses",
  trailingEps: "Earnings Per Share over the last 12 months",
  forwardEps: "Projected Earnings Per Share for the next 12 months",
  quickRatio: "Measure of company's ability to pay short-term obligations (excluding inventory)",
  currentRatio: "Measure of company's ability to pay short-term obligations",
  totalCashPerShare: "Total cash divided by number of shares outstanding",
  shortPercentOfFloat: "Percentage of freely traded shares that are sold short",
  beta: "Measure of stock's volatility compared to the overall market",
  trailingPE: "Price-to-Earnings ratio based on last 12 months of earnings",
  forwardPE: "Price-to-Earnings ratio based on projected next 12 months of earnings",
  priceToBook: "Stock price relative to book value per share - below 1 may indicate undervaluation",
  dividendYield: "Annual dividend payment as a percentage of stock price",
  bookValue: "Net asset value per share (total assets minus total liabilities)",
  alpha12m: "Excess return over the market benchmark (S&P 500) over 12 months - positive means outperformance"
};
